export default {
  mounted () {
    this.messageBox()
  },
  methods: {
    messageBox () {
      const isShow = localStorage.getItem('isTopics')
      if (!isShow) {
        this.$message({
          showClose: true,
          offset: 100,
          message: 'You can double-click to explore the node',
          duration: 4500,
          type: 'warning',
          onClose: () => {
            localStorage.setItem('isTopics', JSON.stringify(true))
          }
        })
      }
    }
  }
}
